import { type ITransferListQuery } from 'application/querySchemas/ITransferListQuery';
import { type ISupportUserTokenRepository } from 'application/repositorySchemas/ISupportUserTokenRepository';
import {
    type ITransferListClient,
} from 'interfaceAdapter/gatewaySchemas/ITransferListClient';
import { inject, injectable } from 'tsyringe';
import { TransferItem } from 'ui/components/supporter/patterns/TransferList/TransferListTable';

@injectable()
export class TransferListQuery implements ITransferListQuery {
    constructor(
        @inject('ISupportUserTokenRepository')
        public readonly supportUserToken: ISupportUserTokenRepository,
        @inject('ITransferListClient')
        public readonly transferListClient: ITransferListClient,
    ) {}

    public async fetch(): Promise<TransferItem[]> {
        const { data, message } = await this.transferListClient.get({
            token: this.supportUserToken.get() || '',
        });
        if (message) {
            throw new Error(message);
        }
        return data as TransferItem[];
    }
}
